export const FEATURES = {
  MANAGEMENT_MODE: process.env.REACT_APP_MANAGEMENT_MODE === "true",
  GS_CERTIFICATION_MODE: process.env.REACT_APP_GS_CERTIFICATION_MODE === "true",
  APF_GROUP_MODE: process.env.REACT_APP_APF_GROUP_MODE === "true",
  S_CORE_MODE: process.env.REACT_APP_S_CORE_MODE === "true",
  DEMO_LOGIN: process.env.REACT_APP_DEMO_LOGIN === "true",
  REPORT_VIEW: process.env.REACT_APP_REPORT_VIEW === "true",
  CACHE_PROGRESS_TIMEOUT: Number(
    process.env.REACT_APP_CACHE_PROGRESS_TIMEOUT || 5000
  ),
} as const;
